
import { Grid, Box, Typography, Button } from "@mui/material";
import React, { memo,FC, ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";
type FitlerSidebarProps={
    children?: ReactNode;
    CloseModal?: any;
    isFilterOpen?: boolean;
    pagesize?: number;
    handleApplyFilter?: any;
    handleResetFilter?: any;
}
const FitlerSidebar:FC<FitlerSidebarProps> = ({
    children,
    CloseModal,
    isFilterOpen,
    pagesize,
    handleApplyFilter,
    handleResetFilter,
}):JSX.Element => {
    return (
        <Box
          sx={{
            width: {md: '35%',lg: '32%', xl: "23%"},
            height: "calc(100% - 60px)",
            backgroundColor: "#fff",
            position: "absolute",
            top: 0,
            right: isFilterOpen === true ? 0 : -500,
            zIndex: 10,
            transition: 'all 0.6s ease',
            boxShadow:
              "rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px",
          }}
        >
          <Box sx={{ height: "100%", overflow: "hidden", }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                paddingTop: "2%",
                paddingRight: "2%",
                height: "4%",
              }}
              onClick={CloseModal}
            >
              <CloseIcon sx={{ color: "#2A3F54", cursor: "pointer" }} />
            </Box>
            <Box sx={{ mx: "4%", my: "2%", height: "7%" }}>
              <Typography
                sx={{ fontSize: 20,  fontWeight: "700" }}
              >
                Filters
              </Typography>
              <Typography
              className="border-b border-gray-300"
                sx={{
                  fontSize: 15,
                  
                  fontWeight: "400",
                  color: "grey",
                  mt: 0.2,

                }}
              >
                Filters will be applied to your List
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                overflowY: "auto",
                height: '75%',
                width: "100%",
                overflowX: "hidden",
                flexDirection:"column"
              }}
            >
              {children}
            </Box>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              mr={"5%"}
              my={{ xl: "3%", lg: "-3%" }}
              position={"relative"}
            // height={'7%'}
            // sx={{ backgroundColor: 'red' }}
            >
              <Box
                component="section"
                sx={{
                  px: 1,
                  py: 1,
                  bgcolor: "#1976D2",
                  "&:hover": {
                    bgcolor: "#003366",
                  },
                  borderRadius: 2,
                  mx: "3%",
                }}
              >
                <Button variant="text" size="small" onClick={handleApplyFilter}>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontSize: 13,
                      fontStyle: "normal",
                      fontWeight: "600",
                      
                    }}
                  >
                    Apply Filters
                    {/* {!!ButtonName ? ButtonName : "New"} */}
                  </Typography>
                </Button>
              </Box>
    
              <Box
                component="section"
                sx={{
                  px: 1,
                  // py: 0.5,
                  py: 1,
                  bgcolor: "#fff",
                  // "&:hover": {
                  //   bgcolor: "#3D154B",
                  // },
                  borderRadius: 2,
                  border: "1px solid #003366",
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  onClick={handleResetFilter}
                >
                  <Typography
                    sx={{
                      color: "#003366",
                      // "&:hover ": {
                      //     color: "#fff",
                      //   },
                      fontSize: 13,
                      fontStyle: "normal",
                      fontWeight: "600",
                      
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    Reset Filters
                    {/* {!!ButtonName ? ButtonName : "New"} */}
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </Box >
      );
}

export default FitlerSidebar
